const styles = {
  menu: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--gray-800)',
    borderRadius: 0,
  },
  switchIsActive: {
    padding: '4px 14px 4px 10px',
  },
  switchIsActiveMedium: {
    padding: '2px 8px 2px 6px',
  },
  switchIsActiveMobile: {
    padding: '2px 8px 2px 6px',
  },
  switchIsInactive: {
    padding: '4px 10px',
  },
  switchIsInactiveMedium: {
    padding: '2px 6px',
  },
  switchIsInactiveMobile: {
    padding: '2px 6px',
  },
};

export default styles;
